(() => {
    angular.module('app').controller('host.views.inpatientGuaranteeLetters.details.page', InpatientGuaranteeLetterDetailController);

    InpatientGuaranteeLetterDetailController.$inject = ['$scope', '$stateParams'];

    function InpatientGuaranteeLetterDetailController($scope, $stateParams) {
        const vm = this;
        vm.loading = 0;
        vm.letterNumber = $stateParams.letterNumber;
        vm.activeTab = _.toInteger($stateParams.tab) || 0;
        vm.memberId = null;
        vm.newRepliedQueriesCount = 0;
        vm.isDetailPage = true;
        vm.currencyCode = abp.setting.get('Hms.General.CurrencyCode');
        vm.timeZoneId = $stateParams.timeZoneId;
        vm.serviceType = $stateParams.serviceType;

        $scope.$on('inpatientGlLoaded', (event) => {
            event.stopPropagation();
            const { serviceTypeName } = event.targetScope.vm;
            if (vm.serviceType == null)
                vm.serviceType = serviceTypeName;
        });
    }
})();
